// Generated on 2026-01-05T16:52:30.339Z
// This file contains preloaded top vehicle data from the API
// Do not edit manually - use 'npm run generate:top-vehicles-data' to regenerate

export const preloadedTopVehicles: any = [
  {
    "marca": "FORD",
    "modelo": "ESCAPE",
    "busquedas": "65765"
  },
  {
    "marca": "HONDA",
    "modelo": "CR-V",
    "busquedas": "64747"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COROLLA",
    "busquedas": "59183"
  },
  {
    "marca": "HONDA",
    "modelo": "CIVIC",
    "busquedas": "49087"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ELANTRA",
    "busquedas": "43766"
  },
  {
    "marca": "KIA",
    "modelo": "SORENTO",
    "busquedas": "20726"
  },
  {
    "marca": "TOYOTA",
    "modelo": "TACOMA",
    "busquedas": "17741"
  },
  {
    "marca": "NISSAN",
    "modelo": "FRONTIER",
    "busquedas": "15894"
  },
  {
    "marca": "FORD",
    "modelo": "EXPLORER",
    "busquedas": "15401"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "L200",
    "busquedas": "13376"
  },
  {
    "marca": "TOYOTA",
    "modelo": "HILUX",
    "busquedas": "13362"
  },
  {
    "marca": "TOYOTA",
    "modelo": "RAV4",
    "busquedas": "12107"
  },
  {
    "marca": "FORD",
    "modelo": "RANGER",
    "busquedas": "11124"
  },
  {
    "marca": "NISSAN",
    "modelo": "FRONTIER NP300 D23",
    "busquedas": "9282"
  },
  {
    "marca": "JEEP",
    "modelo": "PATRIOT",
    "busquedas": "8980"
  },
  {
    "marca": "FORD",
    "modelo": "FOCUS",
    "busquedas": "7647"
  },
  {
    "marca": "TOYOTA",
    "modelo": "4RUNNER",
    "busquedas": "7546"
  },
  {
    "marca": "ISUZU",
    "modelo": "D-MAX",
    "busquedas": "7455"
  },
  {
    "marca": "NISSAN",
    "modelo": "SENTRA",
    "busquedas": "7229"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SANTA FE",
    "busquedas": "7173"
  },
  {
    "marca": "PONTIAC",
    "modelo": "VIBE",
    "busquedas": "6142"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "LANCER",
    "busquedas": "6051"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PICKUP",
    "busquedas": "5830"
  },
  {
    "marca": "HONDA",
    "modelo": "FIT",
    "busquedas": "5545"
  },
  {
    "marca": "MAZDA",
    "modelo": "BT-50",
    "busquedas": "5499"
  },
  {
    "marca": "NISSAN",
    "modelo": "FRONTIER D22",
    "busquedas": "5449"
  },
  {
    "marca": "KIA",
    "modelo": "SPORTAGE",
    "busquedas": "5353"
  },
  {
    "marca": "FORD",
    "modelo": "F-150",
    "busquedas": "4990"
  },
  {
    "marca": "HONDA",
    "modelo": "PILOT",
    "busquedas": "4842"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ACCENT",
    "busquedas": "4764"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "TUCSON",
    "busquedas": "4383"
  },
  {
    "marca": "HONDA",
    "modelo": "ACCORD",
    "busquedas": "4382"
  },
  {
    "marca": "NISSAN",
    "modelo": "ROGUE",
    "busquedas": "4148"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "COLORADO",
    "busquedas": "4000"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER PRADO",
    "busquedas": "3698"
  },
  {
    "marca": "MAZDA",
    "modelo": "3",
    "busquedas": "3369"
  },
  {
    "marca": "NISSAN",
    "modelo": "PATHFINDER",
    "busquedas": "3103"
  },
  {
    "marca": "TOYOTA",
    "modelo": "MATRIX",
    "busquedas": "3020"
  },
  {
    "marca": "JEEP",
    "modelo": "WRANGLER",
    "busquedas": "2928"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SPARK",
    "busquedas": "2881"
  },
  {
    "marca": "KIA",
    "modelo": "RIO",
    "busquedas": "2856"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "OUTLANDER",
    "busquedas": "2660"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MONTERO SPORT",
    "busquedas": "2539"
  },
  {
    "marca": "TOYOTA",
    "modelo": "HIACE",
    "busquedas": "2479"
  },
  {
    "marca": "TOYOTA",
    "modelo": "YARIS",
    "busquedas": "2479"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CAMRY",
    "busquedas": "2243"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SANTA FE SPORT",
    "busquedas": "2010"
  },
  {
    "marca": "MAZDA",
    "modelo": "TRIBUTE",
    "busquedas": "1986"
  },
  {
    "marca": "NISSAN",
    "modelo": "ALTIMA",
    "busquedas": "1957"
  },
  {
    "marca": "KIA",
    "modelo": "SPECTRA",
    "busquedas": "1947"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CRUZE",
    "busquedas": "1925"
  },
  {
    "marca": "NISSAN",
    "modelo": "VERSA",
    "busquedas": "1853"
  },
  {
    "marca": "HONDA",
    "modelo": "ODYSSEY",
    "busquedas": "1824"
  },
  {
    "marca": "MAZDA",
    "modelo": "PROTEGE",
    "busquedas": "1821"
  },
  {
    "marca": "TOYOTA",
    "modelo": "TERCEL",
    "busquedas": "1803"
  },
  {
    "marca": "JEEP",
    "modelo": "COMPASS",
    "busquedas": "1796"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "AMAROK",
    "busquedas": "1762"
  },
  {
    "marca": "JEEP",
    "modelo": "CHEROKEE",
    "busquedas": "1681"
  },
  {
    "marca": "NISSAN",
    "modelo": "NAVARA D40",
    "busquedas": "1644"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "OUTLANDER SPORT",
    "busquedas": "1532"
  },
  {
    "marca": "JEEP",
    "modelo": "GRAND CHEROKEE",
    "busquedas": "1397"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MIRAGE",
    "busquedas": "1338"
  },
  {
    "marca": "TOYOTA",
    "modelo": "TUNDRA",
    "busquedas": "1332"
  },
  {
    "marca": "ISUZU",
    "modelo": "RODEO",
    "busquedas": "1306"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "H-100",
    "busquedas": "1298"
  },
  {
    "marca": "KIA",
    "modelo": "SOUL",
    "busquedas": "1297"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TAHOE",
    "busquedas": "1291"
  },
  {
    "marca": "FORD",
    "modelo": "EDGE",
    "busquedas": "1282"
  },
  {
    "marca": "HONDA",
    "modelo": "HR-V",
    "busquedas": "1251"
  },
  {
    "marca": "MAZDA",
    "modelo": "6",
    "busquedas": "1228"
  },
  {
    "marca": "BMW",
    "modelo": "X3",
    "busquedas": "1227"
  },
  {
    "marca": "KIA",
    "modelo": "PICANTO",
    "busquedas": "1182"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SIENNA",
    "busquedas": "1179"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAX",
    "busquedas": "1102"
  },
  {
    "marca": "TOYOTA",
    "modelo": "HIGHLANDER",
    "busquedas": "1090"
  },
  {
    "marca": "NISSAN",
    "modelo": "XTERRA",
    "busquedas": "1077"
  },
  {
    "marca": "KIA",
    "modelo": "SEPHIA",
    "busquedas": "1066"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MONTERO",
    "busquedas": "1057"
  },
  {
    "marca": "NISSAN",
    "modelo": "D21",
    "busquedas": "1027"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2900",
    "busquedas": "1019"
  },
  {
    "marca": "HONDA",
    "modelo": "ELEMENT",
    "busquedas": "988"
  },
  {
    "marca": "DODGE",
    "modelo": "NEON",
    "busquedas": "985"
  },
  {
    "marca": "NISSAN",
    "modelo": "QASHQAI",
    "busquedas": "985"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "GALANT",
    "busquedas": "979"
  },
  {
    "marca": "NISSAN",
    "modelo": "PICKUP",
    "busquedas": "975"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2500",
    "busquedas": "958"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500",
    "busquedas": "953"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SONATA",
    "busquedas": "943"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "NATIVA",
    "busquedas": "929"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "S10",
    "busquedas": "909"
  },
  {
    "marca": "BMW",
    "modelo": "X5",
    "busquedas": "901"
  },
  {
    "marca": "FORD",
    "modelo": "EXPEDITION",
    "busquedas": "898"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVEO",
    "busquedas": "890"
  },
  {
    "marca": "NISSAN",
    "modelo": "URVAN",
    "busquedas": "839"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER",
    "busquedas": "833"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EQUINOX",
    "busquedas": "817"
  },
  {
    "marca": "FORD",
    "modelo": "MUSTANG",
    "busquedas": "769"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER",
    "busquedas": "767"
  },
  {
    "marca": "NISSAN",
    "modelo": "PATROL",
    "busquedas": "740"
  },
  {
    "marca": "ISUZU",
    "modelo": "PICKUP KB",
    "busquedas": "697"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GRAND STAREX",
    "busquedas": "689"
  },
  {
    "marca": "SUZUKI",
    "modelo": "GRAND VITARA",
    "busquedas": "678"
  },
  {
    "marca": "BMW",
    "modelo": "328I",
    "busquedas": "676"
  },
  {
    "marca": "NISSAN",
    "modelo": "X-TRAIL",
    "busquedas": "674"
  },
  {
    "marca": "FORD",
    "modelo": "F-250 SUPER DUTY",
    "busquedas": "624"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-7",
    "busquedas": "610"
  },
  {
    "marca": "RAM",
    "modelo": "1500",
    "busquedas": "562"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRACKER",
    "busquedas": "556"
  },
  {
    "marca": "JEEP",
    "modelo": "LIBERTY",
    "busquedas": "520"
  },
  {
    "marca": "MERCURY",
    "modelo": "MARINER",
    "busquedas": "520"
  },
  {
    "marca": "HONDA",
    "modelo": "RIDGELINE",
    "busquedas": "504"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2200",
    "busquedas": "499"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "JETTA",
    "busquedas": "497"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "EON",
    "busquedas": "477"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "I10",
    "busquedas": "474"
  },
  {
    "marca": "DODGE",
    "modelo": "DAKOTA",
    "busquedas": "473"
  },
  {
    "marca": "MAZDA",
    "modelo": "626",
    "busquedas": "471"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SONIC",
    "busquedas": "462"
  },
  {
    "marca": "NISSAN",
    "modelo": "MURANO",
    "busquedas": "459"
  },
  {
    "marca": "MAZDA",
    "modelo": "323",
    "busquedas": "454"
  },
  {
    "marca": "FORD",
    "modelo": "ESCORT",
    "busquedas": "451"
  },
  {
    "marca": "MAZDA",
    "modelo": "BT-50 PRO",
    "busquedas": "447"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ECLIPSE",
    "busquedas": "423"
  },
  {
    "marca": "FORD",
    "modelo": "EXPLORER SPORT TRAC",
    "busquedas": "415"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 2500",
    "busquedas": "414"
  },
  {
    "marca": "NISSAN",
    "modelo": "TIIDA",
    "busquedas": "411"
  },
  {
    "marca": "GMC",
    "modelo": "CANYON",
    "busquedas": "408"
  },
  {
    "marca": "NISSAN",
    "modelo": "URVAN NV350",
    "busquedas": "392"
  },
  {
    "marca": "NISSAN",
    "modelo": "NV200",
    "busquedas": "386"
  },
  {
    "marca": "MAZDA",
    "modelo": "2",
    "busquedas": "377"
  },
  {
    "marca": "DODGE",
    "modelo": "CARAVAN",
    "busquedas": "375"
  },
  {
    "marca": "TOYOTA",
    "modelo": "ECHO",
    "busquedas": "372"
  },
  {
    "marca": "FORD",
    "modelo": "FIESTA",
    "busquedas": "366"
  },
  {
    "marca": "JEEP",
    "modelo": "RENEGADE",
    "busquedas": "361"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "L300",
    "busquedas": "357"
  },
  {
    "marca": "SUZUKI",
    "modelo": "ESTEEM",
    "busquedas": "352"
  },
  {
    "marca": "NISSAN",
    "modelo": "JUKE",
    "busquedas": "346"
  },
  {
    "marca": "BMW",
    "modelo": "325I",
    "busquedas": "338"
  },
  {
    "marca": "ISUZU",
    "modelo": "PICKUP",
    "busquedas": "336"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 1500",
    "busquedas": "334"
  },
  {
    "marca": "SCION",
    "modelo": "XA",
    "busquedas": "327"
  },
  {
    "marca": "NISSAN",
    "modelo": "KICKS",
    "busquedas": "327"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CELICA",
    "busquedas": "315"
  },
  {
    "marca": "SUBARU",
    "modelo": "FORESTER",
    "busquedas": "310"
  },
  {
    "marca": "SCION",
    "modelo": "XB",
    "busquedas": "304"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "TIBURON",
    "busquedas": "304"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-5",
    "busquedas": "300"
  },
  {
    "marca": "DODGE",
    "modelo": "GRAND CARAVAN",
    "busquedas": "290"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "PRIZM",
    "busquedas": "276"
  },
  {
    "marca": "SUZUKI",
    "modelo": "VITARA",
    "busquedas": "269"
  },
  {
    "marca": "TOYOTA",
    "modelo": "FORTUNER",
    "busquedas": "260"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2300",
    "busquedas": "249"
  },
  {
    "marca": "SCION",
    "modelo": "TC",
    "busquedas": "247"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAPTIVA",
    "busquedas": "242"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT CONNECT",
    "busquedas": "238"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "H-1",
    "busquedas": "237"
  },
  {
    "marca": "SUZUKI",
    "modelo": "FORENZA",
    "busquedas": "235"
  },
  {
    "marca": "KIA",
    "modelo": "FORTE",
    "busquedas": "234"
  },
  {
    "marca": "KIA",
    "modelo": "OPTIMA",
    "busquedas": "233"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TIGUAN",
    "busquedas": "231"
  },
  {
    "marca": "ACURA",
    "modelo": "RDX",
    "busquedas": "230"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVALANCHE",
    "busquedas": "229"
  },
  {
    "marca": "FORD",
    "modelo": "FUSION",
    "busquedas": "228"
  },
  {
    "marca": "NISSAN",
    "modelo": "NP300",
    "busquedas": "223"
  },
  {
    "marca": "NISSAN",
    "modelo": "350Z",
    "busquedas": "215"
  },
  {
    "marca": "SCION",
    "modelo": "XD",
    "busquedas": "212"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ENDEAVOR",
    "busquedas": "211"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GRAND I10",
    "busquedas": "211"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SX4",
    "busquedas": "209"
  },
  {
    "marca": "NISSAN",
    "modelo": "720",
    "busquedas": "207"
  },
  {
    "marca": "FORD",
    "modelo": "ECOSPORT",
    "busquedas": "205"
  },
  {
    "marca": "RAM",
    "modelo": "2500",
    "busquedas": "192"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SWIFT",
    "busquedas": "190"
  },
  {
    "marca": "NISSAN",
    "modelo": "ARMADA",
    "busquedas": "189"
  },
  {
    "marca": "NISSAN",
    "modelo": "TITAN",
    "busquedas": "186"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SEQUOIA",
    "busquedas": "184"
  },
  {
    "marca": "SUBARU",
    "modelo": "IMPREZA",
    "busquedas": "183"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAMARO",
    "busquedas": "181"
  },
  {
    "marca": "HUMMER",
    "modelo": "H3",
    "busquedas": "181"
  },
  {
    "marca": "SUBARU",
    "modelo": "OUTBACK",
    "busquedas": "180"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAVALIER",
    "busquedas": "179"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "VELOSTER",
    "busquedas": "178"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-9",
    "busquedas": "177"
  },
  {
    "marca": "BMW",
    "modelo": "Z4",
    "busquedas": "175"
  },
  {
    "marca": "SUZUKI",
    "modelo": "AERIO",
    "busquedas": "175"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SIDEKICK",
    "busquedas": "173"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "CRETA",
    "busquedas": "171"
  },
  {
    "marca": "ISUZU",
    "modelo": "TROOPER",
    "busquedas": "165"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2000",
    "busquedas": "163"
  },
  {
    "marca": "ACURA",
    "modelo": "TL",
    "busquedas": "162"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "TERRACAN",
    "busquedas": "162"
  },
  {
    "marca": "ACURA",
    "modelo": "RSX",
    "busquedas": "155"
  },
  {
    "marca": "DODGE",
    "modelo": "CALIBER",
    "busquedas": "152"
  },
  {
    "marca": "TOYOTA",
    "modelo": "T100",
    "busquedas": "151"
  },
  {
    "marca": "DODGE",
    "modelo": "DART",
    "busquedas": "150"
  },
  {
    "marca": "DODGE",
    "modelo": "JOURNEY",
    "busquedas": "149"
  },
  {
    "marca": "NISSAN",
    "modelo": "MAXIMA",
    "busquedas": "149"
  },
  {
    "marca": "MAZDA",
    "modelo": "PROTEGE5",
    "busquedas": "144"
  },
  {
    "marca": "ACURA",
    "modelo": "TSX",
    "busquedas": "142"
  },
  {
    "marca": "SUZUKI",
    "modelo": "APV",
    "busquedas": "140"
  },
  {
    "marca": "SUBARU",
    "modelo": "LEGACY",
    "busquedas": "139"
  },
  {
    "marca": "SATURN",
    "modelo": "VUE",
    "busquedas": "138"
  },
  {
    "marca": "BMW",
    "modelo": "X1",
    "busquedas": "137"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CAPTIVA SPORT",
    "busquedas": "131"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MALIBU",
    "busquedas": "127"
  },
  {
    "marca": "MAZDA",
    "modelo": "5",
    "busquedas": "125"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 3500",
    "busquedas": "125"
  },
  {
    "marca": "ISUZU",
    "modelo": "MU-X",
    "busquedas": "125"
  },
  {
    "marca": "ACURA",
    "modelo": "MDX",
    "busquedas": "122"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "N300",
    "busquedas": "122"
  },
  {
    "marca": "FORD",
    "modelo": "F-350 SUPER DUTY",
    "busquedas": "118"
  },
  {
    "marca": "NISSAN",
    "modelo": "QUEST",
    "busquedas": "116"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "PT CRUISER",
    "busquedas": "114"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "TOWN & COUNTRY",
    "busquedas": "113"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 1500",
    "busquedas": "109"
  },
  {
    "marca": "BMW",
    "modelo": "528I",
    "busquedas": "108"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX300",
    "busquedas": "107"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "METRO",
    "busquedas": "106"
  },
  {
    "marca": "SUZUKI",
    "modelo": "JIMNY",
    "busquedas": "104"
  },
  {
    "marca": "MAZDA",
    "modelo": "MPV",
    "busquedas": "104"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ELANTRA GT",
    "busquedas": "103"
  },
  {
    "marca": "ACURA",
    "modelo": "INTEGRA",
    "busquedas": "102"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "BLAZER",
    "busquedas": "102"
  },
  {
    "marca": "SUZUKI",
    "modelo": "SAMURAI",
    "busquedas": "101"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "PASSAT",
    "busquedas": "101"
  },
  {
    "marca": "NISSAN",
    "modelo": "ALMERA",
    "busquedas": "101"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN",
    "busquedas": "101"
  },
  {
    "marca": "DODGE",
    "modelo": "DURANGO",
    "busquedas": "98"
  },
  {
    "marca": "GEO",
    "modelo": "PRIZM",
    "busquedas": "97"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN 1500",
    "busquedas": "94"
  },
  {
    "marca": "LEXUS",
    "modelo": "GX470",
    "busquedas": "91"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "VERACRUZ",
    "busquedas": "90"
  },
  {
    "marca": "GMC",
    "modelo": "ACADIA",
    "busquedas": "88"
  },
  {
    "marca": "FORD",
    "modelo": "F-250",
    "busquedas": "86"
  },
  {
    "marca": "NISSAN",
    "modelo": "NV350 URVAN",
    "busquedas": "86"
  },
  {
    "marca": "FORD",
    "modelo": "TAURUS",
    "busquedas": "86"
  },
  {
    "marca": "TOYOTA",
    "modelo": "FJ CRUISER",
    "busquedas": "86"
  },
  {
    "marca": "BMW",
    "modelo": "335I",
    "busquedas": "85"
  },
  {
    "marca": "CADILLAC",
    "modelo": "ESCALADE",
    "busquedas": "84"
  },
  {
    "marca": "JEEP",
    "modelo": "GLADIATOR",
    "busquedas": "83"
  },
  {
    "marca": "VOLVO",
    "modelo": "S40",
    "busquedas": "83"
  },
  {
    "marca": "BMW",
    "modelo": "X6",
    "busquedas": "82"
  },
  {
    "marca": "AUDI",
    "modelo": "Q7",
    "busquedas": "81"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAVERSE",
    "busquedas": "81"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER COUNTRYMAN",
    "busquedas": "79"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "MATRIX",
    "busquedas": "79"
  },
  {
    "marca": "HONDA",
    "modelo": "CITY",
    "busquedas": "79"
  },
  {
    "marca": "VOLVO",
    "modelo": "S60",
    "busquedas": "76"
  },
  {
    "marca": "MAZDA",
    "modelo": "B3000",
    "busquedas": "76"
  },
  {
    "marca": "KIA",
    "modelo": "SEDONA",
    "busquedas": "75"
  },
  {
    "marca": "PORSCHE",
    "modelo": "CAYENNE",
    "busquedas": "74"
  },
  {
    "marca": "DODGE",
    "modelo": "AVENGER",
    "busquedas": "74"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "COBALT",
    "busquedas": "73"
  },
  {
    "marca": "ACURA",
    "modelo": "ILX",
    "busquedas": "72"
  },
  {
    "marca": "RAM",
    "modelo": "3500",
    "busquedas": "72"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX60",
    "busquedas": "71"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER PICKUP",
    "busquedas": "70"
  },
  {
    "marca": "BMW",
    "modelo": "328I XDRIVE",
    "busquedas": "69"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "BEAT",
    "busquedas": "69"
  },
  {
    "marca": "ISUZU",
    "modelo": "I-290",
    "busquedas": "65"
  },
  {
    "marca": "BMW",
    "modelo": "330CI",
    "busquedas": "64"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "OPTRA",
    "busquedas": "63"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "200",
    "busquedas": "63"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "BEETLE",
    "busquedas": "62"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "VENTURE",
    "busquedas": "61"
  },
  {
    "marca": "DODGE",
    "modelo": "NITRO",
    "busquedas": "60"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "STAREX",
    "busquedas": "59"
  },
  {
    "marca": "SUZUKI",
    "modelo": "XL-7",
    "busquedas": "59"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TOUAREG",
    "busquedas": "59"
  },
  {
    "marca": "VOLVO",
    "modelo": "XC90",
    "busquedas": "58"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 2500 HD",
    "busquedas": "58"
  },
  {
    "marca": "FORD",
    "modelo": "WINDSTAR",
    "busquedas": "56"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PRIUS",
    "busquedas": "53"
  },
  {
    "marca": "AUDI",
    "modelo": "A4",
    "busquedas": "52"
  },
  {
    "marca": "GMC",
    "modelo": "SONOMA",
    "busquedas": "51"
  },
  {
    "marca": "HONDA",
    "modelo": "PASSPORT",
    "busquedas": "51"
  },
  {
    "marca": "LEXUS",
    "modelo": "LX470",
    "busquedas": "50"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "TRAILBLAZER",
    "busquedas": "50"
  },
  {
    "marca": "KIA",
    "modelo": "PREGIO",
    "busquedas": "50"
  },
  {
    "marca": "TOYOTA",
    "modelo": "AVALON",
    "busquedas": "50"
  },
  {
    "marca": "TOYOTA",
    "modelo": "AVENSIS",
    "busquedas": "49"
  },
  {
    "marca": "KIA",
    "modelo": "SPECTRA5",
    "busquedas": "49"
  },
  {
    "marca": "MAZDA",
    "modelo": "B2600",
    "busquedas": "48"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MIGHTY MAX",
    "busquedas": "48"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C230",
    "busquedas": "48"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "N400",
    "busquedas": "47"
  },
  {
    "marca": "BMW",
    "modelo": "535I",
    "busquedas": "46"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVALANCHE 1500",
    "busquedas": "45"
  },
  {
    "marca": "GMC",
    "modelo": "TERRAIN",
    "busquedas": "45"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MIRAGE G4",
    "busquedas": "45"
  },
  {
    "marca": "FIAT",
    "modelo": "500",
    "busquedas": "44"
  },
  {
    "marca": "LINCOLN",
    "modelo": "MKX",
    "busquedas": "44"
  },
  {
    "marca": "BMW",
    "modelo": "330I",
    "busquedas": "44"
  },
  {
    "marca": "BMW",
    "modelo": "128I",
    "busquedas": "43"
  },
  {
    "marca": "BMW",
    "modelo": "320I",
    "busquedas": "43"
  },
  {
    "marca": "FORD",
    "modelo": "E-350 SUPER DUTY",
    "busquedas": "42"
  },
  {
    "marca": "SUZUKI",
    "modelo": "EQUATOR",
    "busquedas": "42"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ATOS",
    "busquedas": "41"
  },
  {
    "marca": "ISUZU",
    "modelo": "RODEO SPORT",
    "busquedas": "40"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CRESSIDA",
    "busquedas": "40"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GOLF",
    "busquedas": "40"
  },
  {
    "marca": "GMC",
    "modelo": "ENVOY",
    "busquedas": "39"
  },
  {
    "marca": "ISUZU",
    "modelo": "HOMBRE",
    "busquedas": "39"
  },
  {
    "marca": "GMC",
    "modelo": "YUKON",
    "busquedas": "39"
  },
  {
    "marca": "AUDI",
    "modelo": "TT",
    "busquedas": "39"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "RAIDER",
    "busquedas": "39"
  },
  {
    "marca": "NISSAN",
    "modelo": "NP300 FRONTIER",
    "busquedas": "39"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "SEBRING",
    "busquedas": "38"
  },
  {
    "marca": "DODGE",
    "modelo": "CHALLENGER",
    "busquedas": "37"
  },
  {
    "marca": "GEO",
    "modelo": "METRO",
    "busquedas": "36"
  },
  {
    "marca": "LEXUS",
    "modelo": "GX460",
    "busquedas": "36"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GRACE",
    "busquedas": "36"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GENESIS COUPE",
    "busquedas": "36"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "DISCOVERY",
    "busquedas": "36"
  },
  {
    "marca": "SUBARU",
    "modelo": "BAJA",
    "busquedas": "36"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "VENUE",
    "busquedas": "35"
  },
  {
    "marca": "LINCOLN",
    "modelo": "NAVIGATOR",
    "busquedas": "35"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E320",
    "busquedas": "35"
  },
  {
    "marca": "NISSAN",
    "modelo": "ROGUE SPORT",
    "busquedas": "35"
  },
  {
    "marca": "ISUZU",
    "modelo": "I-280",
    "busquedas": "34"
  },
  {
    "marca": "NISSAN",
    "modelo": "CUBE",
    "busquedas": "34"
  },
  {
    "marca": "DODGE",
    "modelo": "CHARGER",
    "busquedas": "34"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "300",
    "busquedas": "34"
  },
  {
    "marca": "BMW",
    "modelo": "325CI",
    "busquedas": "34"
  },
  {
    "marca": "LINCOLN",
    "modelo": "AVIATOR",
    "busquedas": "33"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "IMPALA",
    "busquedas": "33"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SUPRA",
    "busquedas": "33"
  },
  {
    "marca": "BMW",
    "modelo": "525I",
    "busquedas": "33"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "PACIFICA",
    "busquedas": "33"
  },
  {
    "marca": "PONTIAC",
    "modelo": "SOLSTICE",
    "busquedas": "32"
  },
  {
    "marca": "HONDA",
    "modelo": "CROSSTOUR",
    "busquedas": "31"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "HHR",
    "busquedas": "31"
  },
  {
    "marca": "VOLVO",
    "modelo": "S80",
    "busquedas": "31"
  },
  {
    "marca": "FORD",
    "modelo": "FLEX",
    "busquedas": "30"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX4",
    "busquedas": "30"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ELANTRA COUPE",
    "busquedas": "30"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "R350",
    "busquedas": "30"
  },
  {
    "marca": "BMW",
    "modelo": "Z3",
    "busquedas": "30"
  },
  {
    "marca": "BMW",
    "modelo": "323I",
    "busquedas": "30"
  },
  {
    "marca": "LEXUS",
    "modelo": "IS250",
    "busquedas": "30"
  },
  {
    "marca": "MERCURY",
    "modelo": "TRACER",
    "busquedas": "29"
  },
  {
    "marca": "AUDI",
    "modelo": "Q5",
    "busquedas": "29"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "ML350",
    "busquedas": "29"
  },
  {
    "marca": "SCION",
    "modelo": "IQ",
    "busquedas": "28"
  },
  {
    "marca": "PONTIAC",
    "modelo": "TORRENT",
    "busquedas": "28"
  },
  {
    "marca": "INFINITI",
    "modelo": "FX35",
    "busquedas": "28"
  },
  {
    "marca": "FORD",
    "modelo": "BRONCO",
    "busquedas": "28"
  },
  {
    "marca": "ISUZU",
    "modelo": "AMIGO",
    "busquedas": "28"
  },
  {
    "marca": "SUZUKI",
    "modelo": "CELERIO",
    "busquedas": "28"
  },
  {
    "marca": "HUMMER",
    "modelo": "H2",
    "busquedas": "27"
  },
  {
    "marca": "MAZDA",
    "modelo": "MIATA",
    "busquedas": "27"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GTI",
    "busquedas": "27"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CC",
    "busquedas": "27"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ASX",
    "busquedas": "27"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS 1500",
    "busquedas": "27"
  },
  {
    "marca": "TOYOTA",
    "modelo": "STARLET",
    "busquedas": "27"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "GROOVE",
    "busquedas": "26"
  },
  {
    "marca": "PONTIAC",
    "modelo": "SUNFIRE",
    "busquedas": "26"
  },
  {
    "marca": "FORD",
    "modelo": "EXCURSION",
    "busquedas": "26"
  },
  {
    "marca": "KIA",
    "modelo": "CERATO",
    "busquedas": "25"
  },
  {
    "marca": "JAGUAR",
    "modelo": "X-TYPE",
    "busquedas": "25"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "RANGE ROVER",
    "busquedas": "25"
  },
  {
    "marca": "BMW",
    "modelo": "330XI",
    "busquedas": "25"
  },
  {
    "marca": "TOYOTA",
    "modelo": "URBAN CRUISER",
    "busquedas": "25"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "ML320",
    "busquedas": "24"
  },
  {
    "marca": "KIA",
    "modelo": "SELTOS",
    "busquedas": "24"
  },
  {
    "marca": "BMW",
    "modelo": "325XI",
    "busquedas": "24"
  },
  {
    "marca": "LEXUS",
    "modelo": "IS300",
    "busquedas": "24"
  },
  {
    "marca": "VOLVO",
    "modelo": "XC60",
    "busquedas": "24"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 2500",
    "busquedas": "23"
  },
  {
    "marca": "INFINITI",
    "modelo": "G35",
    "busquedas": "23"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "EXCEL",
    "busquedas": "23"
  },
  {
    "marca": "LEXUS",
    "modelo": "ES330",
    "busquedas": "23"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 2500 HD",
    "busquedas": "23"
  },
  {
    "marca": "BMW",
    "modelo": "318I",
    "busquedas": "22"
  },
  {
    "marca": "MAZDA",
    "modelo": "B4000",
    "busquedas": "22"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C300",
    "busquedas": "22"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-3",
    "busquedas": "22"
  },
  {
    "marca": "HONDA",
    "modelo": "INSIGHT",
    "busquedas": "22"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "POLO",
    "busquedas": "22"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LAND CRUISER II",
    "busquedas": "22"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GL450",
    "busquedas": "22"
  },
  {
    "marca": "NISSAN",
    "modelo": "240SX",
    "busquedas": "22"
  },
  {
    "marca": "KIA",
    "modelo": "RONDO",
    "busquedas": "21"
  },
  {
    "marca": "BMW",
    "modelo": "530I",
    "busquedas": "21"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "RANGE ROVER SPORT",
    "busquedas": "21"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "VOYAGER",
    "busquedas": "21"
  },
  {
    "marca": "SUZUKI",
    "modelo": "RENO",
    "busquedas": "21"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C250",
    "busquedas": "21"
  },
  {
    "marca": "FORD",
    "modelo": "E-150",
    "busquedas": "19"
  },
  {
    "marca": "FORD",
    "modelo": "FREESTYLE",
    "busquedas": "19"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TAOS",
    "busquedas": "19"
  },
  {
    "marca": "VOLVO",
    "modelo": "XC70",
    "busquedas": "19"
  },
  {
    "marca": "SATURN",
    "modelo": "SL1",
    "busquedas": "19"
  },
  {
    "marca": "PONTIAC",
    "modelo": "G6",
    "busquedas": "19"
  },
  {
    "marca": "JEEP",
    "modelo": "COMMANDER",
    "busquedas": "19"
  },
  {
    "marca": "RENAULT",
    "modelo": "KOLEOS",
    "busquedas": "19"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX80",
    "busquedas": "19"
  },
  {
    "marca": "SATURN",
    "modelo": "ION",
    "busquedas": "18"
  },
  {
    "marca": "SATURN",
    "modelo": "SL2",
    "busquedas": "18"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "ENTOURAGE",
    "busquedas": "18"
  },
  {
    "marca": "CADILLAC",
    "modelo": "SRX",
    "busquedas": "18"
  },
  {
    "marca": "DAIHATSU",
    "modelo": "TERIOS",
    "busquedas": "18"
  },
  {
    "marca": "FORD",
    "modelo": "CONTOUR",
    "busquedas": "18"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 3500",
    "busquedas": "17"
  },
  {
    "marca": "FORD",
    "modelo": "E-250",
    "busquedas": "17"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COASTER",
    "busquedas": "17"
  },
  {
    "marca": "NISSAN",
    "modelo": "VERSA NOTE",
    "busquedas": "16"
  },
  {
    "marca": "FORD",
    "modelo": "FIGO",
    "busquedas": "16"
  },
  {
    "marca": "BMW",
    "modelo": "X4",
    "busquedas": "16"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX350",
    "busquedas": "16"
  },
  {
    "marca": "TOYOTA",
    "modelo": "VAN",
    "busquedas": "16"
  },
  {
    "marca": "BMW",
    "modelo": "328XI",
    "busquedas": "16"
  },
  {
    "marca": "INFINITI",
    "modelo": "QX56",
    "busquedas": "16"
  },
  {
    "marca": "LEXUS",
    "modelo": "ES300",
    "busquedas": "16"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN 2500",
    "busquedas": "16"
  },
  {
    "marca": "SUBARU",
    "modelo": "XV CROSSTREK",
    "busquedas": "16"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO",
    "busquedas": "15"
  },
  {
    "marca": "KIA",
    "modelo": "SOLUTO",
    "busquedas": "15"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PREVIA",
    "busquedas": "15"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "ECLIPSE CROSS",
    "busquedas": "15"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "NEON",
    "busquedas": "15"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "FREELANDER",
    "busquedas": "15"
  },
  {
    "marca": "PORSCHE",
    "modelo": "BOXSTER",
    "busquedas": "15"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CMV",
    "busquedas": "14"
  },
  {
    "marca": "SUZUKI",
    "modelo": "IGNIS",
    "busquedas": "14"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CORVETTE",
    "busquedas": "14"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "MONTERO IO",
    "busquedas": "14"
  },
  {
    "marca": "TOYOTA",
    "modelo": "RUSH",
    "busquedas": "14"
  },
  {
    "marca": "ISUZU",
    "modelo": "I-MARK",
    "busquedas": "14"
  },
  {
    "marca": "HONDA",
    "modelo": "CR-Z",
    "busquedas": "14"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLK350",
    "busquedas": "14"
  },
  {
    "marca": "TOYOTA",
    "modelo": "YARIS IA",
    "busquedas": "14"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT-150",
    "busquedas": "14"
  },
  {
    "marca": "DAIHATSU",
    "modelo": "SIRION",
    "busquedas": "14"
  },
  {
    "marca": "TOYOTA",
    "modelo": "SOLARA",
    "busquedas": "14"
  },
  {
    "marca": "CADILLAC",
    "modelo": "ESCALADE ESV",
    "busquedas": "13"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "SAVEIRO",
    "busquedas": "13"
  },
  {
    "marca": "AUDI",
    "modelo": "S4",
    "busquedas": "13"
  },
  {
    "marca": "BUICK",
    "modelo": "ENCORE",
    "busquedas": "13"
  },
  {
    "marca": "CADILLAC",
    "modelo": "CTS",
    "busquedas": "13"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "ASTRO",
    "busquedas": "13"
  },
  {
    "marca": "DODGE",
    "modelo": "D350",
    "busquedas": "13"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CROSSFOX",
    "busquedas": "13"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "PALISADE",
    "busquedas": "13"
  },
  {
    "marca": "MERCURY",
    "modelo": "MOUNTAINEER",
    "busquedas": "13"
  },
  {
    "marca": "GMC",
    "modelo": "SAFARI",
    "busquedas": "12"
  },
  {
    "marca": "FORD",
    "modelo": "EXPLORER SPORT",
    "busquedas": "12"
  },
  {
    "marca": "DODGE",
    "modelo": "STRATUS",
    "busquedas": "12"
  },
  {
    "marca": "GEO",
    "modelo": "TRACKER",
    "busquedas": "12"
  },
  {
    "marca": "BMW",
    "modelo": "640I",
    "busquedas": "12"
  },
  {
    "marca": "INFINITI",
    "modelo": "JX35",
    "busquedas": "12"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK300",
    "busquedas": "12"
  },
  {
    "marca": "FORD",
    "modelo": "BRONCO II",
    "busquedas": "12"
  },
  {
    "marca": "NISSAN",
    "modelo": "PATHFINDER ARMADA",
    "busquedas": "12"
  },
  {
    "marca": "FORD",
    "modelo": "FREESTAR",
    "busquedas": "12"
  },
  {
    "marca": "ACURA",
    "modelo": "TLX",
    "busquedas": "12"
  },
  {
    "marca": "VOLVO",
    "modelo": "C70",
    "busquedas": "12"
  },
  {
    "marca": "SUBARU",
    "modelo": "CROSSTREK",
    "busquedas": "11"
  },
  {
    "marca": "KIA",
    "modelo": "CARENS",
    "busquedas": "11"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT-250",
    "busquedas": "11"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-30",
    "busquedas": "11"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 3500 HD",
    "busquedas": "11"
  },
  {
    "marca": "BUICK",
    "modelo": "ENCLAVE",
    "busquedas": "11"
  },
  {
    "marca": "DAEWOO",
    "modelo": "LANOS",
    "busquedas": "11"
  },
  {
    "marca": "JMC",
    "modelo": "VIGUS",
    "busquedas": "11"
  },
  {
    "marca": "KIA",
    "modelo": "CARNIVAL",
    "busquedas": "11"
  },
  {
    "marca": "LEXUS",
    "modelo": "LX450",
    "busquedas": "11"
  },
  {
    "marca": "GMC",
    "modelo": "SAVANA 2500",
    "busquedas": "10"
  },
  {
    "marca": "RENAULT",
    "modelo": "CLIO",
    "busquedas": "10"
  },
  {
    "marca": "FORD",
    "modelo": "E-350 ECONOLINE",
    "busquedas": "10"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX330",
    "busquedas": "10"
  },
  {
    "marca": "MAZDA",
    "modelo": "RX-8",
    "busquedas": "10"
  },
  {
    "marca": "DODGE",
    "modelo": "RAIDER",
    "busquedas": "10"
  },
  {
    "marca": "KIA",
    "modelo": "SONET",
    "busquedas": "10"
  },
  {
    "marca": "CADILLAC",
    "modelo": "XT5",
    "busquedas": "10"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E350",
    "busquedas": "10"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "I20",
    "busquedas": "10"
  },
  {
    "marca": "SUZUKI",
    "modelo": "S-PRESSO",
    "busquedas": "10"
  },
  {
    "marca": "FORD",
    "modelo": "BRONCO SPORT",
    "busquedas": "10"
  },
  {
    "marca": "SUBARU",
    "modelo": "BRAT",
    "busquedas": "9"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CITY EXPRESS",
    "busquedas": "9"
  },
  {
    "marca": "GMC",
    "modelo": "JIMMY",
    "busquedas": "9"
  },
  {
    "marca": "PORSCHE",
    "modelo": "MACAN",
    "busquedas": "9"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "LR2",
    "busquedas": "9"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "ATLAS",
    "busquedas": "9"
  },
  {
    "marca": "BMW",
    "modelo": "325ES",
    "busquedas": "9"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK250",
    "busquedas": "9"
  },
  {
    "marca": "NISSAN",
    "modelo": "MARCH",
    "busquedas": "9"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "K1500",
    "busquedas": "8"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT-350",
    "busquedas": "8"
  },
  {
    "marca": "LEXUS",
    "modelo": "GS300",
    "busquedas": "8"
  },
  {
    "marca": "LEXUS",
    "modelo": "LX570",
    "busquedas": "8"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA",
    "busquedas": "8"
  },
  {
    "marca": "BMW",
    "modelo": "528I XDRIVE",
    "busquedas": "8"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C1500",
    "busquedas": "8"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C1500 SUBURBAN",
    "busquedas": "8"
  },
  {
    "marca": "HONDA",
    "modelo": "PRELUDE",
    "busquedas": "8"
  },
  {
    "marca": "MAZDA",
    "modelo": "MX-5 MIATA",
    "busquedas": "8"
  },
  {
    "marca": "PORSCHE",
    "modelo": "PANAMERA",
    "busquedas": "8"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "VOYAGER",
    "busquedas": "8"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C280",
    "busquedas": "8"
  },
  {
    "marca": "KIA",
    "modelo": "FORTE KOUP",
    "busquedas": "8"
  },
  {
    "marca": "SUBARU",
    "modelo": "BRZ",
    "busquedas": "8"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PRIUS V",
    "busquedas": "8"
  },
  {
    "marca": "BUICK",
    "modelo": "RENDEZVOUS",
    "busquedas": "7"
  },
  {
    "marca": "GMC",
    "modelo": "S15",
    "busquedas": "7"
  },
  {
    "marca": "NISSAN",
    "modelo": "TITAN XD",
    "busquedas": "7"
  },
  {
    "marca": "AUDI",
    "modelo": "A3",
    "busquedas": "7"
  },
  {
    "marca": "VOLVO",
    "modelo": "S70",
    "busquedas": "7"
  },
  {
    "marca": "BMW",
    "modelo": "318IS",
    "busquedas": "7"
  },
  {
    "marca": "PONTIAC",
    "modelo": "GRAND PRIX",
    "busquedas": "7"
  },
  {
    "marca": "BMW",
    "modelo": "650I",
    "busquedas": "7"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C350",
    "busquedas": "7"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER PACEMAN",
    "busquedas": "7"
  },
  {
    "marca": "TOYOTA",
    "modelo": "VENZA",
    "busquedas": "7"
  },
  {
    "marca": "LEXUS",
    "modelo": "LS400",
    "busquedas": "7"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CRUZE LIMITED",
    "busquedas": "7"
  },
  {
    "marca": "FORD",
    "modelo": "F-350",
    "busquedas": "7"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "OUTLANDER PHEV",
    "busquedas": "7"
  },
  {
    "marca": "NISSAN",
    "modelo": "ROGUE SELECT",
    "busquedas": "7"
  },
  {
    "marca": "NISSAN",
    "modelo": "QASHQAI+2",
    "busquedas": "6"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "RABBIT",
    "busquedas": "6"
  },
  {
    "marca": "MASERATI",
    "modelo": "QUATTROPORTE",
    "busquedas": "6"
  },
  {
    "marca": "TOYOTA",
    "modelo": "LITE ACE",
    "busquedas": "6"
  },
  {
    "marca": "TOYOTA",
    "modelo": "MR2",
    "busquedas": "6"
  },
  {
    "marca": "NISSAN",
    "modelo": "STANZA",
    "busquedas": "6"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 2500",
    "busquedas": "6"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C320",
    "busquedas": "6"
  },
  {
    "marca": "BUICK",
    "modelo": "LACROSSE",
    "busquedas": "6"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK430",
    "busquedas": "6"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "FOX",
    "busquedas": "6"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLA250",
    "busquedas": "6"
  },
  {
    "marca": "DAEWOO",
    "modelo": "NUBIRA",
    "busquedas": "6"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SPARK CLASSIC",
    "busquedas": "6"
  },
  {
    "marca": "FORD",
    "modelo": "E-350 ECONOLINE CLUB WAGON",
    "busquedas": "6"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 3500 VAN",
    "busquedas": "6"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "300D",
    "busquedas": "6"
  },
  {
    "marca": "SATURN",
    "modelo": "SL",
    "busquedas": "6"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COROLLA IM",
    "busquedas": "6"
  },
  {
    "marca": "RAM",
    "modelo": "700",
    "busquedas": "6"
  },
  {
    "marca": "HONDA",
    "modelo": "S2000",
    "busquedas": "6"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "EXPO",
    "busquedas": "5"
  },
  {
    "marca": "LEXUS",
    "modelo": "GS350",
    "busquedas": "5"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "LR3",
    "busquedas": "5"
  },
  {
    "marca": "RAM",
    "modelo": "1500 CLASSIC",
    "busquedas": "5"
  },
  {
    "marca": "SUBARU",
    "modelo": "TRIBECA",
    "busquedas": "5"
  },
  {
    "marca": "KIA",
    "modelo": "RIO5",
    "busquedas": "5"
  },
  {
    "marca": "SCION",
    "modelo": "FR-S",
    "busquedas": "5"
  },
  {
    "marca": "MAHINDRA",
    "modelo": "SCORPIO",
    "busquedas": "5"
  },
  {
    "marca": "SATURN",
    "modelo": "LS1",
    "busquedas": "5"
  },
  {
    "marca": "LEXUS",
    "modelo": "NX300",
    "busquedas": "5"
  },
  {
    "marca": "PONTIAC",
    "modelo": "G5",
    "busquedas": "5"
  },
  {
    "marca": "DODGE",
    "modelo": "ATTITUDE",
    "busquedas": "5"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CABRIO",
    "busquedas": "5"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500 LTD",
    "busquedas": "5"
  },
  {
    "marca": "JIM",
    "modelo": "REMAX",
    "busquedas": "5"
  },
  {
    "marca": "TOYOTA",
    "modelo": "CORONA",
    "busquedas": "5"
  },
  {
    "marca": "FORD",
    "modelo": "TAURUS X",
    "busquedas": "5"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500 LD",
    "busquedas": "5"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS 2500",
    "busquedas": "5"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "BREEZE",
    "busquedas": "5"
  },
  {
    "marca": "TOYOTA",
    "modelo": "RAIZE",
    "busquedas": "5"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLS450",
    "busquedas": "5"
  },
  {
    "marca": "INFINITI",
    "modelo": "EX35",
    "busquedas": "5"
  },
  {
    "marca": "JAC",
    "modelo": "X200",
    "busquedas": "5"
  },
  {
    "marca": "JAGUAR",
    "modelo": "S-TYPE",
    "busquedas": "5"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "DIAMANTE",
    "busquedas": "5"
  },
  {
    "marca": "NISSAN",
    "modelo": "370Z",
    "busquedas": "4"
  },
  {
    "marca": "SUBARU",
    "modelo": "GL",
    "busquedas": "4"
  },
  {
    "marca": "FORD",
    "modelo": "E-150 ECONOLINE",
    "busquedas": "4"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLA250",
    "busquedas": "4"
  },
  {
    "marca": "DODGE",
    "modelo": "B1500",
    "busquedas": "4"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "DISCOVERY SPORT",
    "busquedas": "4"
  },
  {
    "marca": "KIA",
    "modelo": "FORTE5",
    "busquedas": "4"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "LR4",
    "busquedas": "4"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C240",
    "busquedas": "4"
  },
  {
    "marca": "AUDI",
    "modelo": "A4 QUATTRO",
    "busquedas": "4"
  },
  {
    "marca": "INFINITI",
    "modelo": "G37",
    "busquedas": "4"
  },
  {
    "marca": "INFINITI",
    "modelo": "G20",
    "busquedas": "4"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "DEFENDER",
    "busquedas": "4"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 2500 VAN",
    "busquedas": "4"
  },
  {
    "marca": "KIA",
    "modelo": "MOHAVE",
    "busquedas": "4"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GENESIS",
    "busquedas": "4"
  },
  {
    "marca": "BMW",
    "modelo": "328CI",
    "busquedas": "4"
  },
  {
    "marca": "PONTIAC",
    "modelo": "G3",
    "busquedas": "4"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK230",
    "busquedas": "4"
  },
  {
    "marca": "PLYMOUTH",
    "modelo": "GRAND VOYAGER",
    "busquedas": "4"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "CROSSFIRE",
    "busquedas": "4"
  },
  {
    "marca": "BMW",
    "modelo": "335D",
    "busquedas": "4"
  },
  {
    "marca": "TOYOTA",
    "modelo": "MR2 SPYDER",
    "busquedas": "4"
  },
  {
    "marca": "MERCURY",
    "modelo": "COUGAR",
    "busquedas": "4"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "UPLANDER",
    "busquedas": "4"
  },
  {
    "marca": "LEXUS",
    "modelo": "LS460",
    "busquedas": "4"
  },
  {
    "marca": "KIA",
    "modelo": "TELLURIDE",
    "busquedas": "4"
  },
  {
    "marca": "BMW",
    "modelo": "320I XDRIVE",
    "busquedas": "4"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GL320",
    "busquedas": "4"
  },
  {
    "marca": "ACURA",
    "modelo": "RL",
    "busquedas": "4"
  },
  {
    "marca": "BMW",
    "modelo": "323CI",
    "busquedas": "4"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "3000GT",
    "busquedas": "4"
  },
  {
    "marca": "BMW",
    "modelo": "325",
    "busquedas": "4"
  },
  {
    "marca": "FORD",
    "modelo": "TRANSIT",
    "busquedas": "4"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "T-CROSS",
    "busquedas": "4"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "BORA",
    "busquedas": "4"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MALIBU LIMITED",
    "busquedas": "4"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 1500 HD",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CORSA",
    "busquedas": "3"
  },
  {
    "marca": "NISSAN",
    "modelo": "200SX",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "X7",
    "busquedas": "3"
  },
  {
    "marca": "GMC",
    "modelo": "ENVOY XL",
    "busquedas": "3"
  },
  {
    "marca": "SUBARU",
    "modelo": "WRX",
    "busquedas": "3"
  },
  {
    "marca": "JEEP",
    "modelo": "WRANGLER JK",
    "busquedas": "3"
  },
  {
    "marca": "DODGE",
    "modelo": "RAM 1500 VAN",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "M3",
    "busquedas": "3"
  },
  {
    "marca": "MINI",
    "modelo": "COOPER CLUBMAN",
    "busquedas": "3"
  },
  {
    "marca": "DAEWOO",
    "modelo": "LEGANZA",
    "busquedas": "3"
  },
  {
    "marca": "LAND ROVER",
    "modelo": "RANGE ROVER EVOQUE",
    "busquedas": "3"
  },
  {
    "marca": "ISUZU",
    "modelo": "AXIOM",
    "busquedas": "3"
  },
  {
    "marca": "FIAT",
    "modelo": "SIENA",
    "busquedas": "3"
  },
  {
    "marca": "FORD",
    "modelo": "AEROSTAR",
    "busquedas": "3"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E550",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS 3500",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MONTE CARLO",
    "busquedas": "3"
  },
  {
    "marca": "SATURN",
    "modelo": "OUTLOOK",
    "busquedas": "3"
  },
  {
    "marca": "DODGE",
    "modelo": "SPRINTER 2500",
    "busquedas": "3"
  },
  {
    "marca": "LINCOLN",
    "modelo": "LS",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "S10 BLAZER",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "540I",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "135I",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "550I",
    "busquedas": "3"
  },
  {
    "marca": "FORD",
    "modelo": "E-150 ECONOLINE CLUB WAGON",
    "busquedas": "3"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX350L",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "335IS",
    "busquedas": "3"
  },
  {
    "marca": "BMW",
    "modelo": "335XI",
    "busquedas": "3"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SUBURBAN 3500 HD",
    "busquedas": "3"
  },
  {
    "marca": "INFINITI",
    "modelo": "Q50",
    "busquedas": "3"
  },
  {
    "marca": "MAZDA",
    "modelo": "MX-5",
    "busquedas": "3"
  },
  {
    "marca": "FORD",
    "modelo": "FIVE HUNDRED",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "R20 SUBURBAN",
    "busquedas": "2"
  },
  {
    "marca": "MERCURY",
    "modelo": "TOPAZ",
    "busquedas": "2"
  },
  {
    "marca": "EAGLE",
    "modelo": "TALON",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SILVERADO 2500 HD CLASSIC",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SPARK EV",
    "busquedas": "2"
  },
  {
    "marca": "CHERY",
    "modelo": "TIGGO 4 PRO",
    "busquedas": "2"
  },
  {
    "marca": "NISSAN",
    "modelo": "210",
    "busquedas": "2"
  },
  {
    "marca": "LEXUS",
    "modelo": "RX450H",
    "busquedas": "2"
  },
  {
    "marca": "NISSAN",
    "modelo": "PULSAR NX",
    "busquedas": "2"
  },
  {
    "marca": "NISSAN",
    "modelo": "TSURU",
    "busquedas": "2"
  },
  {
    "marca": "GMC",
    "modelo": "SAVANA 3500",
    "busquedas": "2"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 1500 CLASSIC",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "AVEO5",
    "busquedas": "2"
  },
  {
    "marca": "LINCOLN",
    "modelo": "CONTINENTAL",
    "busquedas": "2"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 3500 HD",
    "busquedas": "2"
  },
  {
    "marca": "LINCOLN",
    "modelo": "MKS",
    "busquedas": "2"
  },
  {
    "marca": "PEUGEOT",
    "modelo": "206",
    "busquedas": "2"
  },
  {
    "marca": "PEUGEOT",
    "modelo": "306",
    "busquedas": "2"
  },
  {
    "marca": "PONTIAC",
    "modelo": "AZTEK",
    "busquedas": "2"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-50",
    "busquedas": "2"
  },
  {
    "marca": "PONTIAC",
    "modelo": "GRAND AM",
    "busquedas": "2"
  },
  {
    "marca": "MAZDA",
    "modelo": "E2200",
    "busquedas": "2"
  },
  {
    "marca": "PORSCHE",
    "modelo": "911",
    "busquedas": "2"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "AZERA",
    "busquedas": "2"
  },
  {
    "marca": "RAM",
    "modelo": "PROMASTER 1500",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "CMP",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "228I GRAN COUPE",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "428I",
    "busquedas": "2"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "SANTA FE XL",
    "busquedas": "2"
  },
  {
    "marca": "DATSUN",
    "modelo": "PICKUP",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "C200",
    "busquedas": "2"
  },
  {
    "marca": "SATURN",
    "modelo": "AURA",
    "busquedas": "2"
  },
  {
    "marca": "FORD",
    "modelo": "C-MAX",
    "busquedas": "2"
  },
  {
    "marca": "SATURN",
    "modelo": "SC1",
    "busquedas": "2"
  },
  {
    "marca": "SATURN",
    "modelo": "SKY",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "G20",
    "busquedas": "2"
  },
  {
    "marca": "SCION",
    "modelo": "IA",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "E55 AMG",
    "busquedas": "2"
  },
  {
    "marca": "SUZUKI",
    "modelo": "VERONA",
    "busquedas": "2"
  },
  {
    "marca": "BMW",
    "modelo": "M5",
    "busquedas": "2"
  },
  {
    "marca": "FORD",
    "modelo": "F-250 HD",
    "busquedas": "2"
  },
  {
    "marca": "TOYOTA",
    "modelo": "COROLLA CROSS",
    "busquedas": "2"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PASEO",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GL350",
    "busquedas": "2"
  },
  {
    "marca": "JAGUAR",
    "modelo": "XF",
    "busquedas": "2"
  },
  {
    "marca": "FORD",
    "modelo": "MAVERICK",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLC300",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "LUV",
    "busquedas": "2"
  },
  {
    "marca": "JEEP",
    "modelo": "CJ7",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "GOL",
    "busquedas": "2"
  },
  {
    "marca": "JEEP",
    "modelo": "WAGONEER",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "PASSAT CC",
    "busquedas": "2"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "TRANSPORTER",
    "busquedas": "2"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "NOVA",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S320",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S430",
    "busquedas": "2"
  },
  {
    "marca": "VOLVO",
    "modelo": "V70",
    "busquedas": "2"
  },
  {
    "marca": "KIA",
    "modelo": "NIRO",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SL550",
    "busquedas": "2"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK320",
    "busquedas": "2"
  },
  {
    "marca": "JEEP",
    "modelo": "COMANCHE",
    "busquedas": "1"
  },
  {
    "marca": "MITSUBISHI",
    "modelo": "PRECIS",
    "busquedas": "1"
  },
  {
    "marca": "AUDI",
    "modelo": "S5",
    "busquedas": "1"
  },
  {
    "marca": "ASTON MARTIN",
    "modelo": "DBS",
    "busquedas": "1"
  },
  {
    "marca": "TOYOTA",
    "modelo": "PRIUS C",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "FIESTA IKON",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "VIRTUS",
    "busquedas": "1"
  },
  {
    "marca": "LAMBORGHINI",
    "modelo": "MURCIELAGO",
    "busquedas": "1"
  },
  {
    "marca": "JAC",
    "modelo": "T8 PRO",
    "busquedas": "1"
  },
  {
    "marca": "TOYOTA",
    "modelo": "AGYA",
    "busquedas": "1"
  },
  {
    "marca": "JAC",
    "modelo": "JS2",
    "busquedas": "1"
  },
  {
    "marca": "TESLA",
    "modelo": "3",
    "busquedas": "1"
  },
  {
    "marca": "ACURA",
    "modelo": "ZDX",
    "busquedas": "1"
  },
  {
    "marca": "DODGE",
    "modelo": "B250",
    "busquedas": "1"
  },
  {
    "marca": "KIA",
    "modelo": "AMANTI",
    "busquedas": "1"
  },
  {
    "marca": "KIA",
    "modelo": "BORREGO",
    "busquedas": "1"
  },
  {
    "marca": "SUZUKI",
    "modelo": "KIZASHI",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "325IS",
    "busquedas": "1"
  },
  {
    "marca": "SUZUKI",
    "modelo": "EECO CARGO",
    "busquedas": "1"
  },
  {
    "marca": "CADILLAC",
    "modelo": "DTS",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "740IL",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "E-250 ECONOLINE",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK550",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "S550",
    "busquedas": "1"
  },
  {
    "marca": "ISUZU",
    "modelo": "I-370",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "CLK350",
    "busquedas": "1"
  },
  {
    "marca": "SCION",
    "modelo": "IM",
    "busquedas": "1"
  },
  {
    "marca": "SATURN",
    "modelo": "SW2",
    "busquedas": "1"
  },
  {
    "marca": "INFINITI",
    "modelo": "Q60",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "430I",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "EXPRESS PASAJEROS",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "ASPIRE",
    "busquedas": "1"
  },
  {
    "marca": "DAEWOO",
    "modelo": "MATIZ",
    "busquedas": "1"
  },
  {
    "marca": "AUDI",
    "modelo": "TT QUATTRO",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "DAMAS/LABO",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "500SEL",
    "busquedas": "1"
  },
  {
    "marca": "VOLVO",
    "modelo": "V40 CROSS COUNTRY",
    "busquedas": "1"
  },
  {
    "marca": "VOLVO",
    "modelo": "V50",
    "busquedas": "1"
  },
  {
    "marca": "RENAULT",
    "modelo": "SCENIC",
    "busquedas": "1"
  },
  {
    "marca": "FIAT",
    "modelo": "124 SPIDER",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SPRINTER 2500",
    "busquedas": "1"
  },
  {
    "marca": "RENAULT",
    "modelo": "KANGOO",
    "busquedas": "1"
  },
  {
    "marca": "RENAULT",
    "modelo": "CLIO II",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SPRINTER",
    "busquedas": "1"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "GETZ",
    "busquedas": "1"
  },
  {
    "marca": "RAM",
    "modelo": "DAKOTA",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "645CI",
    "busquedas": "1"
  },
  {
    "marca": "HYUNDAI",
    "modelo": "AVANTE",
    "busquedas": "1"
  },
  {
    "marca": "HUMMER",
    "modelo": "H1",
    "busquedas": "1"
  },
  {
    "marca": "MAZDA",
    "modelo": "MILLENIA",
    "busquedas": "1"
  },
  {
    "marca": "MAZDA",
    "modelo": "CX-70",
    "busquedas": "1"
  },
  {
    "marca": "DODGE",
    "modelo": "RAMCHARGER",
    "busquedas": "1"
  },
  {
    "marca": "MAXUS",
    "modelo": "D90",
    "busquedas": "1"
  },
  {
    "marca": "CHRYSLER",
    "modelo": "GRAND VOYAGER",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "SLK350",
    "busquedas": "1"
  },
  {
    "marca": "HONDA",
    "modelo": "CRX",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C3500",
    "busquedas": "1"
  },
  {
    "marca": "PEUGEOT",
    "modelo": "3008",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "C2500",
    "busquedas": "1"
  },
  {
    "marca": "AUDI",
    "modelo": "A7",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "535I XDRIVE",
    "busquedas": "1"
  },
  {
    "marca": "GMC",
    "modelo": "SIERRA 3500",
    "busquedas": "1"
  },
  {
    "marca": "GMC",
    "modelo": "SAVANA 1500",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "SONORA",
    "busquedas": "1"
  },
  {
    "marca": "JMC",
    "modelo": "PICK UP",
    "busquedas": "1"
  },
  {
    "marca": "JMC",
    "modelo": "JX",
    "busquedas": "1"
  },
  {
    "marca": "BMW",
    "modelo": "750LI",
    "busquedas": "1"
  },
  {
    "marca": "FORD",
    "modelo": "THUNDERBIRD",
    "busquedas": "1"
  },
  {
    "marca": "MERCEDES-BENZ",
    "modelo": "GLS350D",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "NIVUS",
    "busquedas": "1"
  },
  {
    "marca": "CHEVROLET",
    "modelo": "MATIZ",
    "busquedas": "1"
  },
  {
    "marca": "VOLKSWAGEN",
    "modelo": "CRAFTER",
    "busquedas": "1"
  }
];

export default preloadedTopVehicles;
